import React from 'react'
import { Upload, Search, FileText } from 'lucide-react'
export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-b from-white to-indigo-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our AI-powered platform makes it easy to get professional feedback
            on your resume in just minutes.
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center mb-12">
            <div className="md:w-1/3 flex justify-center mb-6 md:mb-0">
              <div className="bg-indigo-100 p-6 rounded-full">
                <Upload size={48} className="text-indigo-600" />
              </div>
            </div>
            <div className="md:w-2/3 md:pl-8">
              <h3 className="text-2xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="bg-indigo-600 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3">
                  1
                </span>
                Upload Your Resume
              </h3>
              <p className="text-gray-600">
                Simply drag and drop your resume file or click to upload. We
                support PDF and DOCX formats to make the process seamless.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center mb-12">
            <div className="md:w-1/3 flex justify-center mb-6 md:mb-0 md:order-last">
              <div className="bg-indigo-100 p-6 rounded-full">
                <Search size={48} className="text-indigo-600" />
              </div>
            </div>
            <div className="md:w-2/3 md:pr-8">
              <h3 className="text-2xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="bg-indigo-600 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3">
                  2
                </span>
                AI Analysis
              </h3>
              <p className="text-gray-600">
                Our advanced AI analyzes your resume, examining format, content,
                keywords, and alignment with industry standards.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center mb-12">
            <div className="md:w-1/3 flex justify-center mb-6 md:mb-0">
              <div className="bg-indigo-100 p-6 rounded-full">
                <FileText size={48} className="text-indigo-600" />
              </div>
            </div>
            <div className="md:w-2/3 md:pl-8">
              <h3 className="text-2xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="bg-indigo-600 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3">
                  3
                </span>
                Receive Feedback
              </h3>
              <p className="text-gray-600">
                Send a custom link to your network and collect all their feedback and comments in one organized place.
              </p>
            </div>
          </div>
          {/* <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/3 flex justify-center mb-6 md:mb-0 md:order-last">
              <div className="bg-indigo-100 p-6 rounded-full">
                <Briefcase size={48} className="text-indigo-600" />
              </div>
            </div>
            <div className="md:w-2/3 md:pr-8">
              <h3 className="text-2xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="bg-indigo-600 text-white w-8 h-8 rounded-full flex items-center justify-center mr-3">
                  4
                </span>
                Job Matching
              </h3>
              <p className="text-gray-600">
                Explore job opportunities that match your skills and experience,
                with personalized suggestions to improve your chances.
              </p>
            </div>
          </div> */}
        </div>
        {/* <div className="mt-16 text-center">
          <button className="bg-indigo-600 text-white px-8 py-3 rounded-md hover:bg-indigo-700 transition text-lg font-medium">
            Analyze My Resume Now
          </button>
        </div> */}
      </div>
    </section>
  )
}
